import { CMSLink } from '@/components/Link'
import RichText from '@/components/RichText'
import { Media } from '@/components/Media'
export const ImageGalleryCard = (fence: any) => {
  if (!fence?.image?.url) {
    return null
  }
  return (
    <div className="relative block group rounded-2xl">
      <div className="relative block overflow-hidden">
        <div className="relative overflow-hidden block z-[1] h-[400px] rounded-2xl">
          <Media
            resource={fence?.image}
            alt={(fence?.image && fence.image.alt) || ''}
            imgClassName="w-full h-full object-cover transition-all ease-in-out duration-100 group-hover:scale-110"
            fetchPriority="low"
            loading="lazy"
          />
        </div>

        <div className=" absolute left-0 top-0 bottom-0 w-full h-full bg-[hsla(0,0%,100%,0.5)] group-hover:z-[2] opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-1000 transform  group-hover:translate-y-full"></div>
      </div>
      <div className=" flex flex-col absolute bottom-[30px] left-[30px] right-[30px] transition-all delay-200 duration-1000 ease-in-out origin-bottom scale-y-0 z-[2] group-hover:scale-y-100">
        <span className=" w-[50%] relative inline-block text-[18px] font-medium leading-[18px] capitalize text-white bg-primary px-[30px] py-[11px] rounded-tl-[20px] rounded-tr-[20px]">
          {fence?.caption && (
            <RichText data={fence.caption} enableGutter={false} enableProse={false} />
          )}
        </span>
        {fence?.links?.length > 0 && (
          <div className="relative inline-block  bg-card/30  px-6 py-2 rounded-[20px] rounded-tl-none w-[70%]">
            {fence?.links?.map((item: any, index: any) => {
              const link = item.link
              return (
                <CMSLink
                  key={index}
                  {...link}
                  className=" text-[16px] font-light tracking-[0] leading-[20px] whitespace-nowrap bg-transparent hover:bg-transparent text-white  transition-all duration-300 [font-family:'Open_Sans',Helvetica] hover:text-primary-foreground"
                />
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
